"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkspaceAwareObjectType = exports.WorkspaceStatus = void 0;
var WorkspaceStatus;
(function (WorkspaceStatus) {
  WorkspaceStatus["ACTIVE"] = "ACTIVE";
  WorkspaceStatus["ARCHIVED"] = "ARCHIVED";
})(WorkspaceStatus = exports.WorkspaceStatus || (exports.WorkspaceStatus = {}));
var WorkspaceAwareObjectType;
(function (WorkspaceAwareObjectType) {
  WorkspaceAwareObjectType["TEAM"] = "TEAM";
  WorkspaceAwareObjectType["PLAYBOOK"] = "PLAYBOOK";
  WorkspaceAwareObjectType["INBOX"] = "INBOX";
  WorkspaceAwareObjectType["USER_ROLES"] = "USER_ROLES";
})(WorkspaceAwareObjectType = exports.WorkspaceAwareObjectType || (exports.WorkspaceAwareObjectType = {}));